import { render } from "./NcTabs.vue?vue&type=template&id=97dbd9f8&scoped=true"
import script from "./NcTabs.vue?vue&type=script&lang=js"
export * from "./NcTabs.vue?vue&type=script&lang=js"

import "./NcTabs.vue?vue&type=style&index=0&id=97dbd9f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97dbd9f8"]])

export default __exports__